export default function RoundFeedback({
    outcome,
    scoreDelta,
    scoreBreakdown,
    reactionMs,
}) {
    const message =
        outcome === "correct_buzz"
            ? "Perfect — correct buzz"
            : outcome === "incorrect_buzz"
                ? "Bad buzz — you didn’t have it"
                : outcome === "good_pass"
                    ? "Passed"
                    : outcome === "missed_opportunity"
                        ? "You should have buzzed"
                        : outcome === "too_early"
                            ? "Too early"
                            : outcome === "too_late"
                                ? "Too late"
                                : "";

    return (
        <div className={`round-feedback round-feedback--${outcome ?? "neutral"}`}>
            <div className="round-feedback__message">{message}</div>

            {scoreBreakdown?.callout && (
                <div className="round-feedback__callout">
                    {scoreBreakdown.callout}
                </div>
            )}
            
            {outcome !== "good_pass" && (
                <div className="round-feedback__score">
                    {scoreDelta > 0 ? `+${scoreDelta}` : scoreDelta}
                </div>
            )}

            {scoreBreakdown && (
                <div className="round-feedback__breakdown">
                    {scoreBreakdown.basePoints > 0 && (
                        <div>Correct +{scoreBreakdown.basePoints}</div>
                    )}

                    {scoreBreakdown.speedBonus > 0 && (
                        <div>Fast reaction +{scoreBreakdown.speedBonus}</div>
                    )}

                    {scoreBreakdown.streakMultiplier > 1 && (
                        <div className="round-feedback__bonus--streak">
                            {scoreBreakdown.streak} STREAK ×{scoreBreakdown.streakMultiplier}
                        </div>
                    )}
                </div>
            )}

            {reactionMs !== null && (
                <div className="round-feedback__meta">
                    {reactionMs} ms
                </div>
            )}
        </div>
    );
}